"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * 統計卡片（儀表板、應收帳款、專案毛利）：p-4＋text-2xl
 * 數值 whitespace-nowrap＋overflow-hidden：貨幣字串不換行；h-full：同一列有的卡片有 hint 時仍等高（包在 Link 裡也一樣）
 */
const StatCard = ({ title, value, hint }) => ((0, jsx_runtime_1.jsxs)("div", { className: "h-full bg-white dark:bg-slate-800 p-4 rounded-lg shadow dark:shadow-none dark:border dark:border-line", children: [(0, jsx_runtime_1.jsx)("h3", { className: "text-sm font-medium text-gray-500 dark:text-gray-400 truncate", children: title }), (0, jsx_runtime_1.jsx)("div", { className: "mt-1 text-2xl font-semibold text-gray-900 dark:text-white tabular-nums flex items-center overflow-hidden whitespace-nowrap", children: value }), hint && (0, jsx_runtime_1.jsx)("p", { className: "mt-1 text-[13px] text-fg-secondary truncate", children: hint })] }));
exports.StatCard = StatCard;
